<template>
    <div>
        <v-main>
            <v-container fluid>
                <v-card id="titlecard" flat>
                    <v-row cols="12" no-gutter dense>
                        <v-col cols="11">
                            <h2>{{ this.title }}</h2><h5 class="subtitle-weight">(Nr. of claims in selection: {{ this.filteredClaims.length }})</h5>
                        </v-col>
                        <v-col>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on" medium color="green" v-on:click="exportDataToExcel()" class="ma-5">mdi-microsoft-excel</v-icon>
                                </template>
                                <span>Export data to Excel</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                    <v-row cols="12" no-gutter dense >
                        <v-col cols="2">
                            <v-text-field class="pt-1" dense v-model="search" clearable prepend-icon="mdi-magnify" label="Search through all fields" single-line hide-detail/>
                        </v-col>
                        <!-- add filter on user and status or a combination -->
                        <v-col cols="2" v-if="params[0] != 'user'">
                            <v-select v-model="selected_gebr" v-bind:items="gebr" prepend-icon="mdi-filter-outline" item-value="code" item-text="name" label="Assigned to" dense class="pl-3 pt-1" clearable></v-select>
                        </v-col>     
                        <v-col cols="4">
                            <v-select v-model.lazy="selected_smst" v-bind:items="stats" multiple prepend-icon="mdi-filter-outline" item-value="code" item-text="description" label="Status" dense class="pl-3 pt-1 pr-8" clearable>                        
                                <template v-slot:prepend-item> <!-- selct all + deselect all -->
                                    <v-list-item ripple @mousedown.prevent @click="toggle">
                                        <v-list-item-action>
                                            <v-icon :color="selected_smst.length > 0 ? 'indigo darken-4' : ''">{{ icon }}</v-icon>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title>Select All</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-divider class="mt-2"></v-divider>
                                </template>                                
                                <template v-slot:selection="{ item, index }"> <!-- so the select element will remain single-line and not push the overview down forcing ugly sidebars to show -->
                                    <span>                                    
                                        <span v-if="index <=1"><span v-if="index === 1">,&nbsp;</span>{{ item.description }}</span>
                                        <span v-if="index === 2" class="grey--text">&nbsp;...(+{{ selected_smst.length - 2 }} others)</span>
                                    </span>                                    
                                </template>                            
                            </v-select>            
                        </v-col>  
                        <v-col cols="4">
                            <v-row no-gutters dense>
                                <v-col>
                                    <v-text-field v-model="claimed_display"
                                                    readonly
                                                    dense
                                                    label="Claimed"
                                                    prefix="€"
                                                    class="pt-1 px-1 text-field-style text-grey"></v-text-field>
                                </v-col>
                                <v-col>
                                    <v-text-field v-model="insurer_display"
                                                    readonly
                                                    dense
                                                    label="Insurer"
                                                    prefix="€"
                                                    class="pt-1 px-1 text-field-style text-grey"></v-text-field>
                                </v-col>
                                <v-col>
                                    <v-text-field v-model="guest_display"
                                                    readonly
                                                    dense
                                                    label="guest paid"
                                                    prefix="€"
                                                    class="pt-1 px-1 text-field-style text-grey"></v-text-field>
                                </v-col>
                                <v-col>
                                    <v-text-field v-model="leniency_display"
                                                    readonly
                                                    dense
                                                    label="Leniency"
                                                    prefix="€"
                                                    class="pt-1 px-1 text-field-style text-grey"></v-text-field>
                                </v-col>
                                <v-col>
                                    <v-text-field v-model="inHouse_display"
                                                    readonly
                                                    dense
                                                    label="In-House"
                                                    prefix="€"
                                                    class="pt-1 px-1 text-field-style text-grey"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row cols="12" no-gutter dense >
                        <v-col cols="1">                                             
                            <v-menu
                                v-model="menuDateFrom"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="arrivalDateFromDMY"
                                    label="Arrival (from)"
                                    prepend-icon="mdi-calendar"
                                    clearable
                                    dense
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    class="pr-1"
                                ></v-text-field>
                                </template>
                                <v-date-picker 
                                    v-model="arrivalDateFromISO" 
                                    v-bind:first-day-of-week="1" 
                                    v-on:input="arrivalDateFromDMY = $moment(arrivalDateFromISO).format('DD-MM-YYYY'); menuDateFrom = false"></v-date-picker>
                            </v-menu>                 
                        </v-col>    
                        <v-col cols="1" class="ml-1">                                             
                            <v-menu
                                v-model="menuDateUntil"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="arrivalDateUntilDMY"
                                    label="Arrival (until)"
                                    prepend-icon="mdi-calendar"
                                    clearable
                                    dense
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                    class="pr-1"
                                ></v-text-field>
                                </template>
                                <v-date-picker 
                                    v-model="arrivalDateUntilISO" 
                                    v-bind:first-day-of-week="1" 
                                    v-on:input="arrivalDateUntilDMY = $moment(arrivalDateUntilISO).format('DD-MM-YYYY'); menuDateUntil = false">
                                </v-date-picker>
                            </v-menu>                 
                        </v-col>              
                        <v-col>
                            <v-label>{{this.message}}</v-label>
                        </v-col>             
                    
                    </v-row>
                </v-card>
                <v-row class="row-default">
                    <v-col cols="12" class="px-2">
                        <v-data-table id="x" dense :headers="getHosmHeaders()" :items="filteredClaims" :disable-pagination=true
                            hide-default-footer item-key="activity" :loading="loading"
                            loading-text="Loading data...please wait" fixed-header :search="search"
                            :height="wInnerHeight">   
                            <template v-slot:header.attachments>
                                <v-icon small>mdi-paperclip</v-icon>
                            </template>          
                            <template v-slot:header.sort>
                                <v-icon small>mdi-flag-variant-outline</v-icon>
                            </template>                
                            <template v-slot:item="claim">
                                <tr>
                                    <td class="td_markup row-pointer booking-color">
                                        <span v-on:click="$router.open('/huov/onHuov/' + claim.item.huov_encrid)">{{ claim.item.booking }} <br> <span class="td_markup_xs no-booking-color">Ar. {{claim.item.arrival_dmy}}</span> </span>
                                    </td>
                                    <td class="td_markup"><div v-if="claim.item.cttp_nr==='5'"><v-icon color="error" size="20">mdi-alpha-e-circle</v-icon></div></td>
                                    <td class="td_markup">{{claim.item.partner}}<template v-if="claim.item.partner === 'Airbnb'"> ({{ claim.item.partner_hostname }})</template></td>
                                    <td class="td_markup">{{ $moment(claim.item.created).format("DD-MM-YYYY HH:mm") }}
                                    </td>
                                    <td class="td_markup">{{ claim.item.claim_ins }}
                                    </td>
                                    <td class="td_markup">
                                        <div v-if="claim.item.flag!==''">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <span v-if="claim.item.flag==='red'">
                                                        <v-icon v-bind="attrs" v-on="on" small color="red">mdi-flag-variant</v-icon>
                                                    </span> 
                                                    <span v-else>
                                                        <v-icon v-bind="attrs" v-on="on" small color="orange">mdi-flag-variant</v-icon>
                                                    </span>
                                                </template>
                                                <span>{{ claim.item.flag_expl }}</span>
                                            </v-tooltip>                                          
                                        </div>
                                    </td>
                                    <td class=" td_markup booking-color row-pointer" v-if="params[0] == 'all' || params[0] == 'eign' || params[0] == 'user'">
                                        <span v-on:click="$router.open('/huis/onHuis/' + claim.item.huis_encrid)">{{ claim.item.accommodation }}</span>
                                    </td>
                                    <td class=" td_markup booking-color row-pointer" v-if="params[0] == 'all' || params[0] == 'user'">
                                        <span v-on:click="$router.open('/eign/onEign/' + claim.item.eign_encrid)">{{ claim.item.owner_displayname }}</span>
                                    </td>
                                    <td class="td_markup">{{ claim.item.assigned_displayname }}</td>
                                    <td class="td_markup">
                                        <v-tooltip bottom :max-width="400" offset-y>
                                            <template v-slot:activator="{ on, attrs }">
                                                <span v-bind="attrs" v-on="on">
                                                    {{ claim.item.case_info && claim.item.case_info.length > 30 ? claim.item.case_info.substring(0, 30) + '...' : claim.item.case_info }}
                                                </span>
                                            </template>
                                            <span>{{ claim.item.case_info }}</span>
                                        </v-tooltip>
                                    </td>
                                    <td class="td_markup">
                                        <v-tooltip bottom :max-width="400" offset-y>
                                            <template v-slot:activator="{ on, attrs }">
                                                <span v-bind="attrs" v-on="on">
                                                    {{ claim.item.summary && claim.item.summary.length > 30 ? claim.item.summary.substring(0, 30) + '...' : claim.item.summary }}
                                                </span>
                                            </template>
                                            <span>{{ claim.item.summary }}</span>
                                        </v-tooltip>
                                    </td>
                                    <td class="td_markup">{{ $moment(claim.item.modified).format("DD-MM-YYYY HH:mm") }}</td>
                                    <td class="td_markup" style="text-align:right">{{ claim.item.claimedAmount | nl_numberformat | prefix_euro}}</td>

                                    <td class="td_markup" style="text-align:right">{{ claim.item.paidAmount | nl_numberformat | prefix_euro }}</td>
                                    <td class="td_markup" style="text-align:right">{{ claim.item.guestPaidAmount | nl_numberformat | prefix_euro }}</td>
                                    <td class="td_markup" style="text-align:right">{{ claim.item.leniencyAmount | nl_numberformat | prefix_euro }}</td>
                                    <td class="td_markup" style="text-align:right">{{ claim.item.inHouseAmount | nl_numberformat | prefix_euro }}</td>

                                    <td class="td_markup">{{ claim.item.hosm_smst_display }}</td>
                                    <td class="td_markup">
                                        <div v-if="!!claim.item.attachments">
                                            {{ claim.item.attachments }}
                                        </div>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
        <div v-if="this.params[0] == 'all'">
            <navBar title="Ares - Customer Success" :home="true" type="customersuccess" goto="/task/customer_success/mnCustomerSuccess" />
        </div>
        <div v-else>
            <navBar title="Ares - Overview" :home="true" goto="/task/customer_success/mnCustomerSuccess"/>
        </div>
    </div>
</template>

<script>

import mxgetuser from '@/mixins/getuser';
import mxnumberformat from '@/mixins/amount_nl';
import mxmaxchar from '@/mixins/filtermaxchar';
// import longTextView from '@/components/ui/fields/longTextView.vue';

import navBar from "@/components/ui/navbars/navbar.vue";

export default {
    props: ['param'],
    created() { // set up event bus listener here on created event or get data

        window.addEventListener("resize", this.resizeEventHandler);

        if (this.param != null) {
            this.params = this.param.split(":");
        }
        this.getSmst();
        this.getSmct();
        this.getOverview();
        this.getGebr();
    },
    destroyed() {
        window.removeEventListener("resize", this.resizeEventHandler);
    },
    mounted() {
        console.log('mounted --> window inner height on startup ', this.wInnerHeight);
    },
    components: {
        navBar,
        // longTextView,
    },
    computed: {
        filteredClaims: function(){            
            return this.claims.filter((claim) => {                
                var matches_status;
                if(this.selected_smst === null || this.selected_smst.length === 0 || this.selected_smst.length === this.stats.length){
                    matches_status = true;
                } else {
                    //console.log(JSON.stringify(this.selected_smst));
                    for(let idx=0; idx < this.selected_smst.length; idx++){                         
                        if(claim.hosm_smst.match(this.selected_smst[idx])){
                            matches_status = true;
                            break;
                        }
                    }
                }      
                var matches_user;
                if(this.selected_gebr === null){
                    matches_user = true;
                } else {
                    matches_user = claim.assigned.match(this.selected_gebr)
                }                

                // check the arrival dates
                // 1. one date can be filled
                // 2. both dates can be filled but the from date must be before until date
                var matches_date_range;
                if(this.arrivalDateFromDMY === null && this.arrivalDateUntilDMY === null){
                    matches_date_range = true;
                } else {
                    if(this.arrivalDateFromDMY === null && this.arrivalDateUntilDMY !== null){
                        if(claim.arrival <= this.arrivalDateUntilISO){
                            matches_date_range = true;
                        }
                    }
                    if(this.arrivalDateFromDMY !== null && this.arrivalDateUntilDMY === null){
                        if(claim.arrival >= this.arrivalDateFromISO){
                            matches_date_range = true;
                        }
                    }  
                    if(this.arrivalDateFromDMY !== null && this.arrivalDateUntilDMY !== null){
                        if(this.arrivalDateFromISO > this.arrivalDateUntilISO ){
                             // from date larger then until date = all dates are not valid    
                             matches_date_range = false;
                        }
                        else {
                          if (claim.arrival >= this.arrivalDateFromISO && claim.arrival <= this.arrivalDateUntilISO){
                            matches_date_range = true;
                          }
                        }
                    }                                            
                }

                return matches_user && matches_status && matches_date_range;
            });
        },
        icon: function () {
            if (this.selectAll) return 'mdi-close-box'
            if (this.selectSome) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },
        selectAll: function () {
            return this.selected_smst.length === this.stats.length; // stats declared in mixin
        },
        selectSome: function () {
            return this.selected_smst.length > 0 && !this.selectAll;
        }, 
        claimed: function () {
            var cnt = 0;
            var num;
            this.filteredClaims.forEach((claim) => {
                num = +claim.claimedAmount;
                cnt += num;
            })
            return parseFloat(cnt).toFixed(2);
        },
        insurer: function () {
            var cnt = 0;
            var num;
            this.filteredClaims.forEach((claim) => {
                num = +claim.billingDamagesAmount;
                cnt += num;
            })
            return parseFloat(cnt).toFixed(2);
        },
        guest: function () {
            var cnt = 0;
            var num;
            this.filteredClaims.forEach((claim) => {
                num = +claim.billingGuestPaidAmount;
                cnt += num;
            })
            return parseFloat(cnt).toFixed(2);  
        },          
        leniency: function () {
            var cnt = 0;
            var num;
            this.filteredClaims.forEach((claim) => {
                num = +claim.billingLeniencyAmount;
                cnt += num;
            })
            return parseFloat(cnt).toFixed(2);
        },
        inHouse: function () {
            var cnt = 0;
            var num;
            this.filteredClaims.forEach((claim) => {
                num = +claim.inHouseAmount;
                cnt += num;
            })
            return parseFloat(cnt).toFixed(2);
        },
        // It's not possible to apply a filter on a v-model (like in a table definition). So we have to do it with a custom formatted computed value
        claimed_display: function() {
            return this.to_nl_numberformat(this.claimed);
        },
        insurer_display: function() {
            return this.to_nl_numberformat(this.insurer);
        },
        leniency_display: function() {
            return this.to_nl_numberformat(this.leniency);
        },
        guest_display: function() {
            return this.to_nl_numberformat(this.guest);
        },
        inHouse_display: function() {
            return this.to_nl_numberformat(this.inHouse);
        },
    },
    data() {
        return {
            search: '',
            claims: [],
            loading: false,
            params: [],
            selected_gebr: '',
            selected_smst: [],
            stats:[], 
            causes:[],
            filterstate: '',
            bar_height: 0,
            card_height: 0,
            message: '',
            menuDateFrom: false,
            arrivalDateFromISO: null, 
            arrivalDateUntilISO: null,
            menuDateUntil: false,
            arrivalDateUntilDMY: null, 
            arrivalDateFromDMY: null, 
            wInnerHeight: window.innerHeight - 270, // deduct estimated height for toolbar, searchfield and headers
            title: 'Damage claims overview',
        }
    },
    mixins:[mxgetuser,mxnumberformat,mxmaxchar],  
    methods: {     
        resizeEventHandler() {
            this.wInnerHeight = window.innerHeight - 270; // deduct estimated height for toolbar, searchfield and headers
        },
        toggle() {
            this.$nextTick(() => {
                if (this.selectAll) {
                    this.selected_smst = [];
                } else {
                    this.selected_smst = this.stats.slice(); //
                }
            })
        },          
        setInitialStatusSelection(){            
            this.stats.forEach((element) => {
                if(element.code!=="closed"){ // this one is initially never selected
                    this.selected_smst.push(element.code);
                }
            });
        },
        getOverview() {
            this.loading = true;
            this.$axios
                .post("ares/json/ares/task/customer_success/hosm/getHosmOverviewV4.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHosmOverview"
                    },
                    getHosmOverview: {
                        params: this.params,
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                        this.loading = false;
                    } else {
                        this.claims = res.data.getHosmOverview;
                        this.title += (' ' + res.data.header.entityvalue);
                        this.filterstate = res.data.header.state;
                        if (res.data.header.state === 'open') this.stats = this.stats.filter(element => element.code !== "closed"); // filter out closed status
                        this.loading = false;
                    }
                })
        },
        getSmst() {
            this.$axios
                .post("ares/json/ares/huov/hosm/getSmst.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getSmst"
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.stats = res.data.getSmst;
                        this.setInitialStatusSelection();
                    }
                });
        },               
        getSmct() {
            this.$axios
                .post("ares/json/ares/huov/hosm/getSmct.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getSmsct"
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.causes = res.data.getSmct;
                    }
                });
        },                        
        getHosmHeaders() {
            switch (this.params[0]) {                
                case 'all':
                case 'user': 
                    return [
                        { text: "Booking", value: "booking", sortable: true, width: '6%' },
                        { text: "Ctr", value: "cttp_nr", width: "4%", align: "center", sortable: true },
                        { text: "Partner", value: "partner", sortable: true, width: '5%' },
                        { text: "Filed", value: "created", sortable: true, width: '8%' },
                        { text: "Claim", value: "claim_ins", sortable: true, width: '5%'  },
                        { text: "Flg", value: "sort", sortable: true, width: '5%'},
                        { text: "Accom.", value: "accommodation", sortable: true, width: '5%' },
                        { text: "Owner", value: "owner_displayname", sortable: true, width: '6%' },
                        { text: "Assigned", value: "assigned", sortable: true, width: '6%' },
                        { text: "Case information", value: "case_info", sortable: false, width :'10%' },
                        { text: "Latest development", value: "summary", sortable: false, width: '10%' },
                        { text: "Modfied", value: "modified", sortable: true, width: '8%' },
                        { text: "Claimed", value: "claimedAmount", align: "end", sortable: false, width: '5.5%'  },
                        { text: "Insurer", value: "paidAmount", align: "end", sortable: false, width: '5.5%' },
                        { text: "Guest", value: "guestPaidAmount", align: "end", sortable: false, width: '5.5%' },
                        { text: "Leniency", value: "leniencyAmount", align: "end", sortable: false, width: '5.5%'  },
                        { text: "In-House", value: "inHouseAmount", align: "end", sortable: false, width: '5.5%'  },
                        { text: "Status", value: "hosm_smst_display", sortable: true, width: '5%' },
                        { sortable: false, value: "attachments", align: "end" },
                    ];
                case 'huis':
                    return [
                        { text: "Booking", value: "booking", sortable: true, width: '8%' },
                        { text: "Ctr", value: "cttp_nr", width: "4%", align: "center", sortable: true },
                        { text: "Partner", value: "partner", sortable: true, width: '7%' },
                        { text: "Filed", value: "created_dmy", sortable: true, width: '7%'},
                        { text: "Claim", value: "claim_ins", sortable: true, width: '5%' },
                        { text: "Flag", value: "sort", sortable: true, width: '5%'},
                        { text: "Assigned", value: "assigned", sortable: true, width: '7%' },
                        { text: "Case information", value: "case_info", sortable: false, width :'10%' },
                        { text: "Latest development", value: "summary", sortable: false, width: '10%' },
                        { text: "Modfied", value: "modified_dmy", sortable: true, width: '7%' },
                        { text: "Amount", value: "claimedAmount", align: "end", sortable: false,  width: '5.5%' },
                        { text: "Insurer", value: "paidAmount", align: "end", sortable: false, width: '5.5%' },
                        { text: "Guest", value: "guestPaidAmount", align: "end", sortable: false, width: '5.5%' },
                        { text: "Leniency", value: "leniencyAmount", align: "end", sortable: false, width: '5.5%'  },      
                        { text: "In-House", value: "inHouseAmount", align: "end", sortable: false, width: '5.5%'  },                  
                        { text: "Status", value: "hosm_smst_display", sortable: true, width: '10%' },
                        { sortable: false, value: "attachments", align: "end" },
                    ];
                case 'eign':
                    return [
                        { text: "Booking", value: "booking", sortable: true, width: '8%' },
                        { text: "Ctr", value: "cttp_nr", width: "4%", align: "center", sortable: true },
                        { text: "Partner", value: "partner", sortable: true, width: '5%' },
                        { text: "Filed", value: "created_dmy", sortable: true, width: '7%'},
                        { text: "Claim", value: "claim_ins", sortable: true, width: '5%' },
                        { text: "Flag", value: "sort", sortable: true, width: '5%'},
                        { text: "Accommodation", value: "accommodation", sortable: true, width: '8%' },
                        { text: "Assigned", value: "assigned", sortable: true, width: '7%' },
                        { text: "Case information", value: "case_info", sortable: false, width :'10%' },
                        { text: "Latest development", value: "summary", sortable: false, width: '10%' },
                        { text: "Modfied", value: "modified_dmy", sortable: true, width: '7%' },
                        { text: "Amount", value: "claimedAmount", align: "end", sortable: false,  width: '5.5%' },
                        { text: "Insurer", value: "paidAmount", align: "end", sortable: false, width: '5.5%' },
                        { text: "Guest", value: "guestPaidAmount", align: "end", sortable: false, width: '5.5%' },
                        { text: "Leniency", value: "leniencyAmount", align: "end", sortable: false, width: '5.5%'  },                        
                        { text: "In-House", value: "inHouseAmount", align: "end", sortable: false, width: '5.5%'  },                  
                        { text: "Status", value: "hosm_smst_display", sortable: true, width: '5%' },
                        { sortable: false, value: "attachments", align: "end" },
                    ];

            }
        },
        exportDataToExcel(){

            var e_claims=[];
            var attachments = 0;

            for(let t = 0; t < this.filteredClaims.length; t++ ){
                
                var el = new Object();

                el["Booking"]=this.filteredClaims[t].booking;
                el["Guest"]=this.filteredClaims[t].guest;
                el["Arrival"]=new Date(this.filteredClaims[t].arrival);
                el["Filed"]=new Date(this.filteredClaims[t].created);
                el["Claim"]=this.filteredClaims[t].claim_ins;
                el["Partner"]=this.filteredClaims[t].partner;
                el["Hostname"]=this.filteredClaims[t].partner_hostname;
                el["Accommodation"]=this.filteredClaims[t].accommodation;
                el["Owner"]=this.filteredClaims[t].owner_displayname;
                el["Agent"]=this.filteredClaims[t].rental_expert;
                el["Acco Country"]=this.filteredClaims[t].acco_country;
                el["Guest Country"]=this.filteredClaims[t].guest_country;
                el["Assigned to"]=this.filteredClaims[t].assigned;

                this.causes.forEach(x => {
                    const selectedSmct = this.filteredClaims[t].selected_smct ?? [];
                    el[`${x.description}`] = Array.isArray(selectedSmct) && selectedSmct.includes(x.description) ? '✔' : '';
                });

                el["Case info"]=this.filteredClaims[t].case_info;
                el["Latest Development"]=this.filteredClaims[t].summary;
                el["Modified"]=new Date(this.filteredClaims[t].modified); // formatted so it can be sorted as a date in Excel
                el["Claimed"]=+this.filteredClaims[t].claimedAmount;
                el["Insurer"]=+this.filteredClaims[t].billingDamagesAmount;
                el["Paid by guest"]=+this.filteredClaims[t].billingGuestPaidAmount; // + converts it to a JS number format. Excel handles this correctly
                el["Leniency"]=+this.filteredClaims[t].billingLeniencyAmount; // + converts it to a JS number format. Excel handles this correctly
                el["In-House"]=+this.filteredClaims[t].inHouseAmount; // + converts it to a JS number format. Excel handles this correctly
                el["Status"]=this.filteredClaims[t].hosm_smst_display;
                el["Closed"] = +this.filteredClaims[t].num_closed_events;
                el["Attachments"]=this.filteredClaims[t].attachments;
                el["Handling time"]=this.filteredClaims[t].handling_time;
                e_claims.push(el);

                attachments += el["Attachments"];

            }

            var XLSX = require("xlsx");
            var ws = XLSX.utils.json_to_sheet(e_claims);
            var wb = XLSX.utils.book_new();

            // totals
            var cell = "AI" + (e_claims.length + 3); // 1 = empty line, 1 = columnheaders, 1 is actual line we need to be (=3)
            // the prepended + sign makes sure that Excel understands it's a number. Passing it this way enables you to calculate with the values in Excel.
            XLSX.utils.sheet_add_aoa(ws,[["Totals", +this.claimed, +this.insurer, +this.guest, +this.leniency, +this.inHouse, '', attachments]], {origin: cell}); // we write starting from cell J + number value of cell

            XLSX.utils.book_append_sheet(wb, ws, "Damages");
            XLSX.writeFile(wb, 'damages.xlsx');
        },
        listArrayElements(param) {
            return param.join();
        }
    }
}

</script>

<style scoped>
    .text-field-style >>> .v-text-field__slot input {
        color: grey;
        font-weight: 300; /* 800 being bold so this is less than half bold */
    }    
    .text-grey {
        color: grey !important;
        font-weight: 400 !important; /* 800 being bold so this is half bold */
    }    
    .row-pointer {
        cursor: pointer;
    }

    .row-default {
        cursor: default;
    }

    .size-80{
        font-size: 30%;
    }
    .booking-color {
        color: blue;
    }
    .no-booking-color {
        color: black;
    }    
    .subtitle-weight{
        font-weight: 400;
    }
    .td_markup {
        vertical-align: top;
        border-top: 5px solid transparent;
        font-size: 12px !important
        /* trick to add padding to a TD element (which is not possible with CSS normally) */
    }
    .td_markup_xs {
        font-size: 11px !important
        /* trick to add padding to a TD element (which is not possible with CSS normally) */
    }    
</style>